import { AuthClient } from '@webcatalog/auth-client/auth-client';
import { API_BASE_URL } from '@webcatalog/constants/api-base-url';
import { AUTH_BASE_URL } from '@webcatalog/constants/auth-base-url';
import { AuthClientId } from '@webcatalog/constants/auth-client-ids';
import { COOKIE_DOMAIN } from '@webcatalog/constants/cookie-domain';

export const authClient = new AuthClient({
  apiUrl: API_BASE_URL,
  authUrl: AUTH_BASE_URL,
  clientId: AuthClientId.MARKETING,
  cookieDomain: COOKIE_DOMAIN,
});

export const logInAsync = async (
  pathname: string,
  opts?: { type: 'login' | 'signup' },
) => {
  const loginUrl = await authClient.getLoginUrlAsync(
    // Served by this origin's own server route as of step 13. The path has to
    // stay /api/auth/callback — the auth app keys the web flow off it.
    `${window.location.origin}/api/auth/callback`,
    pathname,
    opts,
  );
  window.location.href = loginUrl;
};
